/**
 * Enables click-and-drag horizontal scrolling (desktop mouse only) for
 * the "Pairs Well With" recommendations strip and the gift-selection strip
 * in the cart drawer. Uses event delegation so it works with content that
 * is rendered dynamically after this script loads.
 */
(function () {
  if (window.__dragScrollInitialized) return;
  window.__dragScrollInitialized = true;

  const DRAG_SELECTOR = '.cart-drawer-recommendations__scroll-container, .gwp-selector__options';
  const DRAG_THRESHOLD = 5;

  let activeContainer = null;
  let startX = 0;
  let startScrollLeft = 0;
  let hasDragged = false;

  function onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    const container = event.target.closest(DRAG_SELECTOR);
    if (!container) return;

    activeContainer = container;
    startX = event.clientX;
    startScrollLeft = container.scrollLeft;
    hasDragged = false;

    // Stop native image drag-and-drop from hijacking pointer capture mid-drag,
    // which otherwise leaves the strip stuck ("vibrating") when a drag starts
    // on a product image.
    if (event.target.tagName === 'IMG') {
      event.preventDefault();
    }
  }

  function onPointerMove(event) {
    if (!activeContainer) return;

    const delta = event.clientX - startX;
    if (!hasDragged && Math.abs(delta) < DRAG_THRESHOLD) return;

    if (!hasDragged) {
      hasDragged = true;
      activeContainer.classList.add('drag-scroll-active');
    }

    activeContainer.scrollLeft = startScrollLeft - delta;
  }

  function endDrag() {
    if (!activeContainer) return;
    activeContainer.classList.remove('drag-scroll-active');
    activeContainer = null;
  }

  function onClickCapture(event) {
    if (!hasDragged) return;
    event.preventDefault();
    event.stopPropagation();
    hasDragged = false;
  }

  document.addEventListener('pointerdown', onPointerDown);
  document.addEventListener('pointermove', onPointerMove);
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('click', onClickCapture, true);
})();
